import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { RichText, Text } from "@sitecore-jss/sitecore-jss-react";

const SelectionPanel = ({ fields, location }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (item) => {
        const isInView = item[0].isIntersecting;
        setIsScrolled(!isInView);
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      },
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  const params = new URLSearchParams(location.search);

  const processor =
    fields.data.item.soundProcessorFolder.targetItem.processors.find(
      ({ id }) => id === params.get("processor-id"),
    );
  const device = fields.data.item.deviceFolder.targetItem.devices.find(
    ({ id }) => id === params.get("device-id"),
  );
  const model = device?.models.find(({ id }) => id === params.get("model-id"));

  const handleLinkChange = (searchParam, urlPath) => {
    params.delete("sc_site"); // ssr param

    params.delete(searchParam);

    if (searchParam === "device-id") {
      params.delete("model-id");
    }

    const newUrl = new URL(urlPath, window.location.origin);
    newUrl.search = params.toString();

    window.location.href = newUrl.toString();
  };

  const createSelectionPanelItem = ({
    title,
    image,
    name,
    onClick,
    changeText,
  }) => (
    <li key={title}>
      <Text className="selection-panel-text" field={title} tag="div" />
      <div className="selection-card">
        <RichText field={image} className="selection-card-image" />
        <Text className="selection-card-title" field={name} tag="div" />
        <button className="selection-card-link" onClick={onClick}>
          {changeText}
        </button>
      </div>
    </li>
  );

  const selectionPanelItems = [
    processor
      ? {
          title: fields.data.item.processorTitle,
          image: processor.image,
          name: processor.name,
          onClick: () =>
            handleLinkChange(
              "processor-id",
              fields.data.item.changeProcessorLink.url,
            ),
          changeText: fields.data.item.changeProcessorLink.text,
        }
      : null,
    device
      ? {
          title: fields.data.item.deviceTitle,
          image: device.image,
          name: device.name,
          onClick: () =>
            handleLinkChange(
              "device-id",
              fields.data.item.changeDeviceLink.url,
            ),
          changeText: fields.data.item.changeDeviceLink.text,
        }
      : null,
    model
      ? {
          title: fields.data.item.modelTitle,
          image: device.image,
          name: model.name,
          onClick: () =>
            handleLinkChange("model-id", fields.data.item.changeDeviceLink.url),
          changeText: fields.data.item.changeDeviceLink.text,
        }
      : null,
  ]
    .filter(Boolean)
    .map(createSelectionPanelItem);

  return (
    <div
      className={`selection-panel${
        processor || device || model ? "" : " empty"
      }`}
      ref={containerRef}
    >
      <div className="l-padding">
        <a
          className="selection-panel-start-over-link"
          href={`${fields.data.item.startOverLink.url}`}
        >
          <span className="selection-panel-start-over-link-icon" />
          <span className="selection-panel-start-over-link-text">
            {fields.data.item.startOverLink.text}
          </span>
        </a>

        {processor || device || model ? (
          <div className="selection-panel-list-container">
            <ul>{selectionPanelItems}</ul>
          </div>
        ) : null}
      </div>

      {processor || device || model ? (
        <div
          aria-hidden={isScrolled ? undefined : true}
          className={`selection-panel sticky${isScrolled ? " scrolled" : ""}`}
        >
          <div className="l-padding">
            <a
              className="selection-panel-start-over-link"
              href={`${fields.data.item.startOverLink.url}`}
              tabIndex={isScrolled ? undefined : -1}
            >
              <span className="selection-panel-start-over-link-icon" />
              <span className="selection-panel-start-over-link-text">
                {fields.data.item.startOverLink.text}
              </span>
            </a>

            <div className="selection-panel-list-container">
              <ul>{selectionPanelItems}</ul>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default withRouter(SelectionPanel);
